import * as Common from './common';
import type { CommandContext as _CommandContext } from './common/context';
import { CustomerContext } from './customer';
import type { SystemCommandContext as _SystemCommandContext } from './customer/common';
import { FeatureFlag as _FeatureFlag } from './featureFlag';
import { ImportContext } from './import';

export namespace DomainV2 {
  // contexts
  export import Customer = CustomerContext;
  export import Import = ImportContext;

  // common
  export import ImmutableEntity = Common.ImmutableEntity;
  export import MutableEntity = Common.MutableEntity;
  export import SystemImmutableEntity = Common.SystemImmutableEntity;
  export import SystemMutableEntity = Common.SystemMutableEntity;
  export type AggregationRoot = Common.AggregationRoot;
  export type MergeableEntity = Common.MergeableEntity;
  export import Identifier = Common.Identifier;
  export import SequentialId = Common.SequentialId;
  export import UniqueId = Common.UniqueId;
  export import UniqueShortId = Common.UniqueShortId;

  export type CommandContext = _CommandContext;
  export type SystemCommandContext = _SystemCommandContext;

  export import FeatureFlag = _FeatureFlag;
}
